import { render, staticRenderFns } from "./DialogConfirmDelete.vue?vue&type=template&id=6e0b142e"
import script from "./DialogConfirmDelete.vue?vue&type=script&lang=ts"
export * from "./DialogConfirmDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports